"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugUploadError = exports.debugUploadResponse = exports.debugUpload = void 0;
// Debug utility for upload issues
const debugUpload = (file, formData) => {
    console.group('🔍 Upload Debug Info');
    console.log('File:', {
        name: file.name,
        type: file.type,
        size: file.size,
        lastModified: file.lastModified,
    });
    console.log('FormData entries:');
    for (const [key, value] of formData.entries()) {
        console.log(`  ${key}:`, value);
    }
    console.groupEnd();
};
exports.debugUpload = debugUpload;
const debugUploadResponse = (response, data) => {
    console.group('📡 Upload Response Debug');
    console.log('Response status:', response.status);
    console.log('Response headers:', Object.fromEntries(response.headers.entries()));
    console.log('Response data:', data);
    console.groupEnd();
};
exports.debugUploadResponse = debugUploadResponse;
const debugUploadError = (error, context) => {
    console.group('❌ Upload Error Debug');
    console.log('Context:', context);
    console.log('Error:', error);
    console.log('Error message:', error === null || error === void 0 ? void 0 : error.message);
    console.log('Error stack:', error === null || error === void 0 ? void 0 : error.stack);
    console.groupEnd();
};
exports.debugUploadError = debugUploadError;
